import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useCreateWorkflowIdMutation } from './api/createProjectApiSlice';
import { clearAllWizardStates, setWorkflowId } from './state/createProjectSlice';
import { getAnnotationToolAdminProjectsPath } from '../../lib';
import { useAppDispatch } from '../../lib/store';

interface UseCreateProjectWizardScreenResult {
  requiredFieldsFilled: boolean;
  setRequiredFieldsFilled: (requiredFieldsFilled: boolean) => void;
  handleCancelProjectCreation: () => void;
}

export const useCreateProjectWizardScreen = (): UseCreateProjectWizardScreenResult => {
  const dispatch = useAppDispatch();
  const [requiredFieldsFilled, setRequiredFieldsFilled] = useState<boolean>(false);
  const [createWorkflowId, { data: workflowIdData, isLoading: isWorkflowIdLoading }] =
    useCreateWorkflowIdMutation();

  useEffect(() => {
    void createWorkflowId();
  }, [createWorkflowId]);

  useEffect(() => {
    if (workflowIdData?.data && !isWorkflowIdLoading) {
      dispatch(setWorkflowId(workflowIdData.data));
    }
  }, [dispatch, workflowIdData, isWorkflowIdLoading]);

  const navigate = useNavigate();
  const handleCancelProjectCreation = () => {
    dispatch(clearAllWizardStates());
    navigate(getAnnotationToolAdminProjectsPath());
  };

  return {
    requiredFieldsFilled,
    setRequiredFieldsFilled,
    handleCancelProjectCreation,
  };
};
